/**
 * Eventos mapeados da aplicação
 * Todos os eventos de tracking devem ser definidos aqui para manter a consistência
 */

export enum EventType {
  CLICK = 'click',
  VIEW = 'view',
  SUBMIT = 'submit',
  ERROR = 'error',
  TRANSACTIONAL = 'transacional',
}

/**
 * Interface base para payloads de eventos
 */
export interface BaseEventPayload {
  idMedico: number;
  idParceiro: number;
  isMobile: boolean;
  timestamp: string;
}

/**
 * Evento: Posologia Incompleta
 * Monitora interação com prescrição incompleta
 */
export interface PrescriptionIncompletePosologyPayload extends BaseEventPayload {
  idPrescription: number;
}

/**
 * Evento: Quotas SNCR carregadas
 * Registra quais cotas foram retornadas pelo getQuotas. `feature_flag` indica
 * se a listagem filtrada (apenas cotas retornadas) está ativa.
 */
export interface SncrQuotasLoadedPayload extends BaseEventPayload {
  quotas: string[];
  feature_flag: boolean;
}

/**
 * Mapa de eventos da aplicação
 * Cada evento deve ter um nome único e um tipo
 */
export const TRACKED_EVENTS = {
  PRESCRIPTION_INCOMPLETE_POSOLOGY_ADD: {
    name: 'prescription_incomplete_posology_add_btn_click',
    type: EventType.CLICK,
  },
  PRESCRIPTION_ITEM_REMOVE: {
    name: 'prescription_item_remove',
    type: EventType.CLICK,
  },
  PRESCRIPTION_ITEM_EDIT: {
    name: 'prescription_item_edit',
    type: EventType.CLICK,
  },
  OFFICE_SIGN_UP_SIDEBAR_CLICK: {
    name: 'CREDENTIALS',
    type: EventType.CLICK,
  },
  OFFICE_SEND_SIGNUP_PHONE_NUMBER_CLICK: {
    name: 'SEND',
    type: EventType.CLICK,
  },
  OFFICE_CLOSE_SIDEBAR_CLICK: {
    name: 'CLOSE',
    type: EventType.CLICK,
  },
  OFFICE_GO_BACK_CLICK: {
    name: 'BACK',
    type: EventType.CLICK,
  },
  OFFICE_SWITCH_NUMBER_CLICK: {
    name: 'SWITCH',
    type: EventType.CLICK,
  },
  OFFICE_RESEND_WHATSAPP_LINK_CLICK: {
    name: 'RESEND',
    type: EventType.CLICK,
  },
  OFFICE_CONFIRM_PHONE_NUMBER_CLICK: {
    name: 'CONFIRM',
    type: EventType.CLICK,
  },
  OFFICE_ALTER_PHONE_NUMBER_CLICK: {
    name: 'SWITCH',
    type: EventType.CLICK,
  },
  CONSENT_DIALOG_CLOSE: {
    name: 'CLOSE',
    type: EventType.CLICK,
  },
  CONSENT_DIALOG_LATER: {
    name: 'LATER',
    type: EventType.CLICK,
  },
  CONSENT_DIALOG_CONSENT: {
    name: 'CONSENT',
    type: EventType.CLICK,
  },
  SNCR_QUOTAS_LOADED: {
    name: 'sncr_quotas_loaded',
    type: EventType.VIEW,
  },
} as const;

/**
 * Tipo auxiliar para garantir type-safety nos nomes dos eventos
 */
export type TrackedEventName = (typeof TRACKED_EVENTS)[keyof typeof TRACKED_EVENTS]['name'];
